<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="600px"
  >
    <!--<editor-fold desc="DialogTitle">-->
    <template slot="dialogTitle">
      <span v-if="serviceTaskTypeDirty.id">
        Edit Task Type
      </span>
      <span v-else>
        Add New Task Type
      </span>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Content/Form">-->
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <!--<editor-fold desc="Title">-->
      <v-text-field
        v-model="serviceTaskTypeDirty.title"
        outlined
        label="Title"
      />
      <!--</editor-fold>-->

      <!--<editor-fold desc="Description">-->
      <v-subheader>
        Description
      </v-subheader>
      <v-textarea
        v-model="serviceTaskTypeDirty.description"
        outlined
        single-line
      />
      <!--</editor-fold>-->

      <v-switch
        v-model="serviceTaskTypeDirty.checklist_use"
        label="Use in checklists"
      />

      <v-switch
        v-model="serviceTaskTypeDirty.checklist_browse_all"
        label="Has to browse through all elements"
      />

      <v-switch
        v-model="serviceTaskTypeDirty.checklist_extras"
        label="Used as extras"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      @confirmed="destroy()"
    />

    <!--<editor-fold desc="DialogActions">-->
    <template slot="dialogActions">
      <v-btn
        v-if="$can('delete', 'ServiceTaskType')"
        color="error"
        text
        @click="toggleConfirmationDialog(true)"
      >
        Delete
      </v-btn>
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ServiceTaskType from '@/models/ServiceTaskType'
import ContentDialog from '@/components/helpers/Dialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'

export default {
    name: 'ServiceTaskTypeEditDialog',
    components: {
      ConfirmDeleteDialog,
      ContentDialog
    },
    mixins: [ deleteConfirmationMixin ],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      serviceTaskType: {
        type: Object,
        default: () => ServiceTaskType.emptyModel
      }
    },
    data() {
      return {
        serviceTaskTypeDirty: cloneDeep(this.serviceTaskType),
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    watch: {
      serviceTaskType() {
        this.serviceTaskTypeDirty = cloneDeep(this.serviceTaskType)
      }
    },
    methods: {
      async submit() {
        let validation = await this.$validator.validate()

        if (!validation) return

        this.save()
      },
      async save() {
        this.submitting = true

        let formData = {
          title: this.serviceTaskTypeDirty.title,
          description: this.serviceTaskTypeDirty.description,
          checklist_use: this.serviceTaskTypeDirty.checklist_use,
          checklist_browse_all: this.serviceTaskTypeDirty.checklist_browse_all,
          checklist_extras: this.serviceTaskTypeDirty.checklist_extras
        }

        try {
          let serviceTaskType = await ServiceTaskType.api.save(formData, this.serviceTaskTypeDirty.id)
          this.$store.dispatch('alert', {
            'text': 'Task type saved',
            'color': 'success'
          })
          this.$emit(this.serviceTaskTypeDirty.id ? 'serviceTaskType:updated' : 'serviceTaskType:created', serviceTaskType)

          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        } finally {
          this.submitting = false
        }
      },
      async destroy() {
        this.deleting = true

        try {
          await ServiceTaskType.api.destroy(this.serviceTaskTypeDirty.id)

          this.$store.dispatch('alert', {
            'text': 'Task type successfully deleted',
            'color': 'success'
          })
          this.$emit('serviceTaskType:deleted', this.serviceTaskTypeDirty)

          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        } finally {
          this.deleteConfirmationDialogVisible = false
          this.deleting = false
        }
      }
    }
  }
</script>
